import { Seo } from "@/components/Seo";
import { breadcrumbJsonLd } from "@/components/Breadcrumb";
import { PageHero } from "@/components/PageHero";
import { BodySections } from "@/components/service/BodySections";
import { FaqBlock, faqJsonLd } from "@/components/FaqBlock";
import { CtaBand } from "@/components/home/CtaBand";

export default function GuidePage({ guide }) {
  const breadcrumb = [
    { label: "Home", to: "/" },
    { label: "Advice", to: "/advice" },
    { label: guide.name, to: guide.path },
  ];
  const jsonLd = [breadcrumbJsonLd(breadcrumb), faqJsonLd(guide.faqs)];

  return (
    <div data-testid={`guide-page-${guide.id}`}>
      <Seo title={guide.title} description={guide.metaDescription} jsonLd={jsonLd} />
      <PageHero eyebrow="Advice & Guides" h1={guide.h1} intro={guide.intro} breadcrumb={breadcrumb} />
      <BodySections sections={guide.sections} />
      <FaqBlock heading="Common Questions" faqs={guide.faqs} />
      <CtaBand />
    </div>
  );
}
